import styled from 'styled-components';
const typeColor = {
  success: 'semanticPositiveBackground',
  error: 'semanticErrorBackground'
};
const textTypeColor = {
  success: 'semanticPositiveText',
  error: 'semanticError'
};
export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 0.1rem 2rem;
  z-index: ${props => props.theme.zIndex.notification};
  background-color: ${({
  type,
  theme
}) => theme.palette[typeColor[type]]};
  color: ${({
  type,
  theme
}) => theme.palette[textTypeColor[type]]};

  transition: transform 0.2s ease-in-out ${({
  'data-visible': visible
}) => visible ? '' : ', opacity 0s 0.2s linear'};
  transform: ${({
  'data-visible': visible
}) => visible ? 'translateY(0)' : 'translateY(-100%)'};
  opacity: ${({
  'data-visible': visible
}) => visible ? '1' : '0'};
  text-align: center;
`;
//# sourceMappingURL=styles.js.map